import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SearchActorNameModel } from '../../Models/Domains/Account/SearchActorNameModel';

declare var IS_RUNNING_IN_APP_POOL;

export class SearchActorNameClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(inputString: string): Promise<Array<SearchActorNameModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/SearchActorName/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { inputString: inputString }

    return AjaxWrapper.get<Array<SearchActorNameModel>, any>(url, data);
  }
}

